import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import PropTypes from 'prop-types';

const ConfirmDialog = ({
    open,
    onValidate,
    onCancel,
    title,
    validationText,
    mainSentence,
    softDisplay,
}) => {
    return (
        <Dialog
            fullWidth
            maxWidth="sm"
            open={open}
            onClose={onCancel}
            aria-labelledby="delete-project-modal-title"
            aria-describedby="delete-project-modal-description"
        >
            <DialogTitle id="delete-project-modal-title" variant="h6" component="h2">
                {title ? title : 'Are you sure ?'}
            </DialogTitle>
            <DialogContent>{mainSentence}</DialogContent>
            <DialogActions>
                <Button onClick={onCancel} color="dark" sx={{ textTransform: 'unset' }}>
                    Cancel
                </Button>
                <Button
                    onClick={onValidate}
                    color={softDisplay ? 'primary' : 'error'}
                    sx={{ textTransform: 'unset' }}
                    variant="contained"
                >
                    {validationText ? validationText : 'Confirm'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

ConfirmDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onValidate: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    title: PropTypes.string,
    validationText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    mainSentence: PropTypes.element,
    softDisplay: PropTypes.bool,
};

export default ConfirmDialog;
